function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M28.524,4.371L28.52,4.368c-0.137-1.034-0.529-2.017-1.145-2.859c-0.764-0.771-1.801-1.21-2.887-1.22 C20.458,0,14.412,0,14.412,0h-0.016c0,0-6.048,0-10.079,0.291C3.231,0.301,2.194,0.74,1.43,1.511 C0.815,2.353,0.422,3.336,0.285,4.37C0.106,5.918,0.01,7.475-0.003,9.033v2.187c0.013,1.557,0.109,3.113,0.288,4.662 c0.136,1.033,0.53,2.018,1.146,2.861c0.876,0.777,2.004,1.215,3.176,1.23c2.306,0.221,9.8,0.289,9.8,0.289s6.056-0.01,10.085-0.299 c1.084-0.012,2.121-0.451,2.883-1.221c0.615-0.844,1.01-1.826,1.146-2.859c0.18-1.549,0.277-3.105,0.293-4.664V9.035 C28.8,7.476,28.704,5.919,28.524,4.371z M11.428,13.868V5.774l7.783,4.062L11.428,13.868z"
});

var SvgIconYt = function SvgIconYt(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "28.811px",
    height: "20.264px",
    viewBox: "0 0 28.811 20.264",
    enableBackground: "new 0 0 28.811 20.264",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconYt, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-yt.e649ac1b.svg";
export { ForwardRef as ReactComponent };